<div class="container-fluid py-2 py-md-3 px-0">
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <h2 class="mb-0">Eventi</h2>
      @if (canCreateEvent) {
        <button type="button" class="btn btn-primary" (click)="goToAdd()">
          <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Evento
        </button>
      }
    </div>
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <div class="btn-group" role="group" aria-label="Vista catalogo eventi">
        <button
          type="button"
          class="btn"
          [class.btn-primary]="view() === 'list'"
          [class.btn-outline-primary]="view() !== 'list'"
          [attr.aria-pressed]="view() === 'list'"
          (click)="setView('list')"
        >
          <i class="bi bi-grid me-1" aria-hidden="true"></i>Lista
        </button>
        <button
          type="button"
          class="btn"
          [class.btn-primary]="view() === 'map'"
          [class.btn-outline-primary]="view() !== 'map'"
          [attr.aria-pressed]="view() === 'map'"
          (click)="setView('map')"
        >
          <i class="bi bi-map me-1" aria-hidden="true"></i>Mappa
        </button>
      </div>
    </div>
  </div>

  @if (!isMine()) {
    @if (!isAdvancedSearch()) {
      <div class="event-search-bar-container mb-4">
        <div class="row g-2 align-items-center">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text search-icon-addon">
                <i class="bi bi-search" aria-hidden="true"></i>
              </span>
              <input
                type="search"
                class="form-control search-input"
                placeholder="Cerca eventi per nome, luogo, organizzazione..."
                [formControl]="searchControl"
                aria-label="Cerca eventi"
              />
              @if (searchControl.value) {
                <button
                  class="btn btn-outline-secondary border-start-0"
                  type="button"
                  (click)="clearSearch()"
                  aria-label="Cancella ricerca"
                >
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="mb-4">
        <app-catalog-advanced-filter
          mode="event"
          [allEvents]="events()"
          [includePast]="includePast()"
          [initialValues]="advancedFilters()"
          (filterChange)="onAdvancedFilterChange($event)"
          (includePastChange)="onIncludePastChange($event)"
          (resetFilter)="onAdvancedFilterReset()"
          (close)="closeAdvancedSearch()"
        ></app-catalog-advanced-filter>
      </div>
    }
  }

  @if (includePast() && !isMine()) {
    <div class="alert alert-info mb-3 py-2 text-center" role="alert">
      <small>Stai visualizzando anche gli eventi passati.</small>
    </div>
  }

  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
        <span class="visually-hidden">Caricamento eventi in corso...</span>
      </div>
    </div>
  } @else if (view() === 'list') {
    <app-paginated-list [items]="visibleEvents()" colClass="col-12 col-sm-6 col-md-4 col-lg-3" [pageSize]="8">
      <ng-template let-event>
        <app-event-card [event]="event"></app-event-card>
      </ng-template>
    </app-paginated-list>
  } @else {
    @if (visibleEvents().length > 0) {
      <p class="text-muted small mb-2">
        {{ mappableCount() }} di {{ visibleEvents().length }} eventi sulla mappa.
        @if (mappableCount() < visibleEvents().length) {
          Gli altri non hanno coordinate.
        }
      </p>
    }
    <app-osm-map
      [markers]="mapMarkers()"
      ariaLabel="Mappa degli eventi"
      emptyMessage="Nessun evento con coordinate. La posizione si imposta in creazione o modifica."
    ></app-osm-map>
  }
</div>
